import HeaderImg from "./HeaderImg"

export default HeaderImg
